export const compileBucket = "r3z-test-eu";
